export default {
  setSelectedService({ commit }, service) {
    commit("SET_SELECTED_SERVICE", service);
  },
  setBoxCalculateBy({ commit }, boxCalculateBy) {
    commit("SET_BOX_CALCULATE_BY", boxCalculateBy);
  },
  setBoxWeight({ commit }, boxWeight) {
    commit("SET_BOX_WEIGHT", boxWeight);
  },
  setBoxVolume({ commit }, boxVolume) {
    commit("SET_BOX_VOLUME", boxVolume);
  },
  setTotalPallets({ commit }, totalPallets) {
    commit("SET_TOTAL_PALLETS", totalPallets);
  },
  setLooseOption({ commit }, looseOption) {
    commit("SET_LOOSE_OPTION", looseOption);
  },
  setMaterialDimentions({ commit }, materialDimentions) {
    commit("SET_MATERIAL_DIMENTIONS", materialDimentions);
  },
  setTransportOption({ commit }, transportOption) {
    commit("SET_TRANSPORT_OPTION", transportOption);
  },
  resetAll({ commit }) {
    commit("RESET_ALL");
  },
};